import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../../general/Checkbox';
import Text from '../../../typography/Text';
import Icon from '../../../general/Icon';
import Avatar from '../../../general/Avatar';
var Option = /*#__PURE__*/memo(function (_ref) {
  var option = _ref.option,
    isMulti = _ref.isMulti,
    classes = _ref.classes,
    override = _ref.override,
    isSelected = _ref.isSelected,
    onChange = _ref.onChange,
    checkboxColor = _ref.checkboxColor,
    checkBoxIsMonotone = _ref.checkBoxIsMonotone,
    isTruncated = _ref.isTruncated;
  var rootClasses = [classes.option, option.className];
  if (option.isDisabled) rootClasses.push(classes.optionDisabled);
  if (option.subLabel) rootClasses.push(classes.optionTwoLines);
  if (isSelected) rootClasses.push(classes.optionSelected);
  var bulletClasses = [classes.optionLabelBullet];
  var iconClasses = [classes.optionLabelIcon];
  var customIconClasses = [classes.optionLabelCustomIcon];
  if (option.isDisabled) {
    bulletClasses.push(classes.optionLabelBulletDisabled);
    iconClasses.push(classes.optionDisabledIcon);
    customIconClasses.push(classes.optionDisabledIcon);
  } else if (option.type) {
    if (option.type === 'primary') bulletClasses.push(classes.optionLabelBulletPrimary);
    if (option.type === 'danger') bulletClasses.push(classes.optionLabelBulletDanger);
    if (option.type === 'success') bulletClasses.push(classes.optionLabelBulletSuccess);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClasses.join(' ')
  }, override.option || {}, {
    onClick: !option.isDisabled ? onChange(option) : undefined
  }), isMulti && /*#__PURE__*/React.createElement(Checkbox, {
    className: classes.optionCheckbox,
    override: override.optionCheckbox || {},
    color: checkboxColor,
    isMonotone: checkBoxIsMonotone,
    isDisabled: option.isDisabled,
    checked: isSelected
  }), option.type && /*#__PURE__*/React.createElement("div", _extends({
    className: bulletClasses.join(' ')
  }, override.optionLabelBullet || {})), !isMulti && option.iconType && /*#__PURE__*/React.createElement(Icon, _extends({
    className: iconClasses.join(' '),
    name: option.iconType,
    color: option.iconColor || null,
    size: "medium"
  }, override.optionLabelIcon)), !isMulti && option.icon && /*#__PURE__*/React.createElement("div", _extends({
    className: customIconClasses.join(' ')
  }, override.optionLabelCustomIcon), option.icon), !isMulti && option.src && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabelAvatar
  }, override.optionLabelAvatar), option.isDisabled && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionDisabledAvatar
  }, override.optionDisabledAvatar)), /*#__PURE__*/React.createElement(Avatar, {
    size: "small",
    src: option.src,
    placeholder: option.placeholder || '',
    alt: option.alt
  })), !option.subLabel && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabel
  }, override.optionLabel || {}), /*#__PURE__*/React.createElement(Text, {
    type: "body",
    isTruncated: isTruncated
  }, option.label)), !isMulti && option.subLabel && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabelBlock
  }, override.optionLabelBlock || {}), /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabel
  }, override.optionLabel || {}), /*#__PURE__*/React.createElement(Text, {
    type: "body",
    isTruncated: isTruncated
  }, option.label)), /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionSubLabel
  }, override.optionSubLabel || {}), /*#__PURE__*/React.createElement(Text, {
    type: "caption",
    isTruncated: isTruncated,
    color: "neutral700"
  }, option.subLabel))));
});
Option.defaultProps = {
  isTruncated: true
};
process.env.NODE_ENV !== "production" ? Option.propTypes = {
  option: PropTypes.array,
  isMulti: PropTypes.bool,
  classes: PropTypes.object,
  override: PropTypes.object,
  isSelected: PropTypes.bool,
  onChange: PropTypes.func,
  checkboxColor: PropTypes.string,
  checkBoxIsMonotone: PropTypes.bool,
  isTruncated: PropTypes.string
} : void 0;
export default Option;